// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_Lvc","cls2":"MarketingPageLayout-cls2_hLT MarketingPageLayout-cls1_Lvc"};